import axios from "axios";

export const deleteCompanyCancellation = (companyId) => {
  return axios.delete(`/company/cancellations/${companyId}`);
};

export const deleteCompanyPrepay = (companyId) => {
  return axios.delete(`/company/prepay/${companyId}`);
};

export const getChargebeeInvoiceDownload = (params) => {
  return axios.get("/company/billing/chargebee_invoice_download", {
    params,
    responseType: "blob",
  });
};

export const getCharbebeePortalSession = () => {
  return axios.get("/api/frontend/chargebee_portal_sessions");
};

export const getRewardBilling = () => {
  return axios.get("/company/billing/reward_billing_card");
};

export const getRewardBalanceRewardGrouping = (params) => {
  return axios.get("/company/billing/reward_balance_reward_grouping", {
    params,
  });
};

export const getRewardsCSVDowload = (params) => {
  return axios.get("/company/billing/reward_balance_csv", {
    params
  });
};

export const getInProgressGeneratedFile = (params) => {
  return axios.get("/api/v1/generated_files?recent=true&generating=true");
};

export const getGeneratedFile = (params) => {
  return axios.get(`/api/v1/generated_files/${params.id}`);
};

export const setGeneratedFileDownloadedAt = (params) => {
  return axios.put(`/api/v1/generated_files/${params.id}`, { downloaded: true });
};

export const getChargebeePayNowUrl = () => {
  return axios.get("/company/billing/chargebee_pay_now_url");
};

export const getCompanyBillingPage = () => {
  return axios.get("/company/billing/billing_page");
};

export const getPurchaseOrderNumbers = (companyId) => {
  return axios.get(`/company/billings/po_number/${companyId}`);
};

export const getRecentInvoices = (params) => {
  return axios.get("/company/billing/recent_invoices_card", { params });
};

export const getRewardBalance = (params) => {
  return axios.get("/company/billing/reward_balance_card", { params });
};

export const getSubscriptionBilling = () => {
  return axios.get("/company/billing/subscription_billing_card");
};

export const postCancelAccount = (data) => {
  return axios.post("/company/cancellations", data);
};

export const postEnableAutoCollect = (subscriptionId) => {
  return axios.post(
    `/company/settings/subscriptions/${subscriptionId}/enable_autocollection`
  );
};

export const postManualInvoice = (data) => {
  return axios.post("/super_admin/companies/rewards_invoices", data);
};

export const postRewardBalanceAdjustment = (data) => {
  return axios.post("/company/credits", data);
};

export const postSetupPrepay = (data) => {
  return axios.post("/company/prepay", data);
};

export const putModifyPrepay = (companyId, data) => {
  return axios.put(`/company/prepay/${companyId}`, data);
};

export const updateCatalogOverride = (data) => {
  return axios.put("/company/billing/update_catalog_override", data);
};

export const updatePurchaseOrderNumbers = (companyId, data) => {
  return axios.put(`/company/billings/po_number/${companyId}`, data);
};

export const updateCompanyCatalogShutoff = (data) => {
  return axios.put("/company/billing/update_company_catalog_shutoff", data);
};

export const submitFeedback = (data) => {
  return axios.post("/beta_feedbacks", data);
};

export const updateProductTier = (data) => {
  return axios.patch("/company/plans/update_product_tier", data);
};

export const updateToAnnual = () => {
  return axios.get("/company/plans/upgrade_to_annual");
};
